import React from "react";
export default function SmallButtonExternal({ label, link, className }) {
  return (
    <a href={link} target={"_blank"} rel='noopener noreferrer' className={`small-btn ${className}`}>
      {label}
    </a>
  );
}
